import { render } from "./estoque_acessorio.vue?vue&type=template&id=1ce5ac48"
import script from "./estoque_acessorio.vue?vue&type=script&lang=js"
export * from "./estoque_acessorio.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__